$(function(){

    //$(".group2").colorbox({rel:'group2', transition:"fade", maxWidth:"70%", maxHeight: "90%", photo: true});

    $("#print_button").click(function(){
        $("div.PrintArea").printArea({mode: "iframe", extraCss: "/public/css/site/print.css" });
    });


    $('#fontA_button').click(function(){
        var tamanhoFonte = $('.noticia-info').css('font-size');
        var tf = parseFloat(tamanhoFonte);
        if(tf < 29){
            $(".noticia-info").css({'font-size' : tf + 5});
        }
    });

    $('#fontD_button').click(function(){
        var tamanhoFonte = $('.noticia-info').css('font-size');
        var tf = parseFloat(tamanhoFonte);
        if(tf > 14){
            $(".noticia-info").css({'font-size' : tf - 5});
        }
    });

    $('#textB_button').click(function(){
        var backG = $('.noticia-info').css('background-color');
        if(backG == 'rgb(0, 0, 0)'){
            $(".noticia-info").css({'background-color' : '#fff'});
            $(".noticia-info").css({'color' : '#333'});
        }else{
            $(".noticia-info").css({'color' : 'yellow'});
            $(".noticia-info").css({'background-color' : '#000'});
        }
    });

    // Abrir popup Facebook
    $('.btn-acess-noti-share').click(function(){
		let url = $(this).attr('url');
		let pos_t = ($(window).height() / 2) - 200;
		let pos_l = ($(window).width() /2 ) - 300;
		window.open(url, '', `toolbar=no,scrollbars=no,resizable=no,top=${pos_t},left=${pos_l},width=600,height=400`);
	});
});

(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = "//connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=v2.3";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
